// marginx-specific visibility rules for the shared shortcut registry. Kept out of
// `src/keyboard/` (authored identically across apps) because it reads this
// app's feature flags: a shortcut for a vertical the build does not offer is
// hidden everywhere it is listed — the `?` modal, the /shortcuts page, the
// chord overlay and the hint bar — and long/short wording drops to buy/sell
// when there are no perpetuals.
import { InstrumentTypeResponse } from "../../codegen-api";
import {
  getAccountSurfaceFlags,
  isInstrumentTypeEnabled,
} from "../../config/features";
import type { ShortcutDef } from "keyboard/types";

/**
 * False for an entry tied to a vertical this build does not offer.
 *
 * `go.history` has no single vertical: /historical holds option settlements and
 * perp funding, so with neither (a spot-only build) it has no tab and redirects
 * to trading -- advertising G H there sends the trader nowhere.
 */
export const isShortcutAvailable = (entry: {
  id?: string;
  requiresInstrument?: string;
}): boolean => {
  if (entry.id === "go.history" && !getAccountSurfaceFlags().showDerivativeUi) {
    return false;
  }
  return (
    !entry.requiresInstrument ||
    isInstrumentTypeEnabled(entry.requiresInstrument as InstrumentTypeResponse)
  );
};

/** The label to show for a shortcut on this build. */
export const shortcutLabel = (
  def: Pick<ShortcutDef, "label" | "labelWithoutPerps">
): string =>
  def.labelWithoutPerps &&
  !isInstrumentTypeEnabled(InstrumentTypeResponse.Perpetual)
    ? def.labelWithoutPerps
    : def.label;
